
import { Options, Vue } from "vue-class-component";
import HeaderBody from "@/components/HeaderBody.vue";
import Carousel from "@/components/Carousel.vue";
import MainBody from "@/components/MainBody.vue";
import MainBottom from "@/components/MainBottom.vue";
@Options({
  components: {
    Carousel,
    MainBody,
    MainBottom,HeaderBody
  },
  props: {
    msg: String,
  },
})
export default class HelloWorld extends Vue {
  msg!: string;
}
